import DeclareLocation from './DeclareLocation'
export default DeclareLocation
